import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    projectType: "",
    message: "",
  });
  const [status, setStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [honeypot, setHoneypot] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (honeypot.trim()) {
      console.log("Bot detected by honeypot");
      return;
    }
    setStatus("submitting");
    try {
      const payload = new FormData();
payload.append("access_key", "3636cfed-e75d-44d4-bcfc-bdd3bfdc35d0");
payload.append("subject", "New Quote Request from Castillo Painting Website");
payload.append("from_name", "Castillo Painting Website");

Object.entries(formData).forEach(([key, value]) => {
  payload.append(key, value);
});

const res = await fetch("https://api.web3forms.com/submit", {
  method: "POST",
  body: payload,
});
      const data = await res.json();

    console.log("Web3Forms response:", data);

    if (data.success) {
      setStatus("success");
      setFormData({
        name: "",
        email: "",
        phone: "",
        projectType: "",
        message: "",
      });
    } else {
      console.error("Web3Forms error:", data);
      setStatus("error");
    }
  } catch (error) {
    console.error("Form submission error:", error);
    setStatus("error");
  }
};

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <section className="pt-28 pb-16 px-4 md:px-8 lg:px-12 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-flex items-center border border-foreground-300 rounded-full px-5 py-1.5 text-xs font-medium tracking-wider uppercase text-foreground-600 mb-6">
                Get in Touch
              </div>
              <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-foreground-950 mb-4">
                Contact Us
              </h1>
              <p className="text-foreground-600 max-w-lg mx-auto">
                Ready to start your project? Reach out for a free quote or consultation.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-12">
              <div className="lg:col-span-1 space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                    <i className="ri-phone-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">Phone</p>
                    <a href="tel:9514792556" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      (951) 479-2556
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                    <i className="ri-map-pin-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">Location</p>
                    <p className="text-sm text-foreground-600">Corona, CA</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                    <i className="ri-shield-check-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">License</p>
                    <p className="text-sm text-foreground-600">#1150059</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                    <i className="ri-instagram-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">Instagram</p>
                    <a href="https://instagram.com/castillo_painting_inc" target="_blank" rel="noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      @castillo_painting_inc
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                    <i className="ri-tiktok-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">TikTok</p>
                    <a href="https://www.tiktok.com/@jcjunkhauling?_r=1&_t=ZP-98CuOyratu3" target="_blank" rel="noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      @jcjunkhauling
                    </a>
                  </div>
                </div>
                <div className="bg-background-100 rounded-xl p-6 mt-4">
                  <p className="text-sm font-medium text-foreground-950 mb-2">Service Areas</p>
                  <div className="flex flex-wrap gap-2">
                    {[
                      "Riverside County",
                      "San Bernardino County",
                      "Orange County",
                      "San Diego County",
                      "Los Angeles County",
                    ].map((area) => (
                      <span key={area} className="bg-background-50 text-foreground-600 text-xs px-3 py-1 rounded-full border border-background-300">
                        {area}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              <div className="lg:col-span-2">
                <form onSubmit={handleSubmit} className="bg-background-100 rounded-2xl p-6 md:p-8 space-y-5">
                  <div style={{ display: "none" }}>
              <input
                type="text"
                name="botcheck"
                value={honeypot}
                onChange={(e) => setHoneypot(e.target.value)}
                tabIndex={-1}
                autoComplete="off"
                  />
                </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-medium text-foreground-700 mb-1.5">Full Name</label>
                      <input type="text" name="name" value={formData.name} onChange={handleChange} required className="w-full bg-background-50 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 placeholder-foreground-400 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors" placeholder="Your name" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-foreground-700 mb-1.5">Email</label>
                      <input type="email" name="email" value={formData.email} onChange={handleChange} required className="w-full bg-background-50 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 placeholder-foreground-400 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors" placeholder="your@email.com" />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-medium text-foreground-700 mb-1.5">Phone</label>
                      <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full bg-background-50 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 placeholder-foreground-400 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors" placeholder="(555) 000-0000" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-foreground-700 mb-1.5">Project Type</label>
                      <select name="projectType" value={formData.projectType} onChange={handleChange} required className="w-full bg-background-50 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors">
                        <option value="">Select a project type</option>
                        <option value="interior">Interior Painting</option>
                        <option value="exterior">Exterior Painting</option>
                        <option value="residential">Residential</option>
                        <option value="commercial">Commercial</option>
                        <option value="repair">Wood / Stucco Repair</option>
                        <option value="pressure">Pressure Washing</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">Project Details</label>
                    <textarea name="message" value={formData.message} onChange={handleChange} maxLength={500} rows={4} className="w-full bg-background-50 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 placeholder-foreground-400 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors resize-none" placeholder="Tell us about your project..."></textarea>
                    <p className="text-xs text-foreground-400 mt-1 text-right">{formData.message.length}/500</p>
                  </div>
                  <button type="submit" disabled={status === "submitting"} className="w-full bg-primary-500 text-background-50 py-3.5 rounded-full text-sm font-medium tracking-wider uppercase hover:bg-primary-600 transition-colors disabled:opacity-60 whitespace-nowrap cursor-pointer">
                    {status === "submitting" ? "Submitting..." : "Submit Request"}
                  </button>
                  {status === "success" && <p className="text-sm text-primary-600 text-center">Thank you! We will contact you shortly.</p>}
                  {status === "error" && <p className="text-sm text-red-600 text-center">Something went wrong. Please try again.</p>}
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
